import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { Tag } from '../types/tag.type';
import { UpdateTagRequestDTO } from '../types/dtos/update-tag.dto';
import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_TAGS_API_PATHS } from '../constants/tags-api-paths.constants';

type UseUpdateTagResult = {
  isSubmitting: boolean;
  updateTag: (tagId: string, tagData: UpdateTagRequestDTO) => Promise<Tag | null>;
};

export function useUpdateTag(): UseUpdateTagResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateTag = async (tagId: string, tagData: UpdateTagRequestDTO): Promise<Tag | null> => {
    setIsSubmitting(true);

    try {
      const updatedTag = await HttpClient.patch<Tag, UpdateTagRequestDTO>(
        ADMIN_TAGS_API_PATHS.UPDATE_TAG(tagId),
        tagData
      );

      enqueueSnackbar('Le tag a été renommé', { variant: 'success' });
      return updatedTag;
    } catch (error) {
      enqueueSnackbar(extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors du renommage du tag'), {
        variant: 'error',
      });
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, updateTag };
}
